// File: /src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCPUCBdLjlvudIfci9_n6qge8CApLE-0KY",
  authDomain: "nft-verification-5b929.firebaseapp.com",
  projectId: "nft-verification-5b929",
  storageBucket: "nft-verification-5b929.appspot.com",
  messagingSenderId: "662117918276",
  appId: "1:662117918276:web:ea638219154604a9ba3e11",
  measurementId: "G-D9VBN6P3MD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Analytics (optional, only if needed)
const analytics = getAnalytics(app);

// Export the Firestore instance for use in your components
export { db };

